import { getOffers, addToCart } from '../api';
import TypeSelector from './TypeSelector';
import CapacitySelector from './CapacitySelector';
import DurationSelector from './DurationSelector';
import FormSummary, { Price } from './FormSummary';
import ScrollView from './shared/ScrollView';

import { __ } from './utils';



export default ({ type, present = false }) => {
	
	const [loaded, setLoaded] = React.useState(0);
	const [saving, setSaving] = React.useState(false);
	const [formData, setFormData] = React.useState({
		type,
		capacity: null,
		duration: null,
		product_id: null,
		only_red_wine: false,
		is_present: present,
		product: null,
		message: '',
	});
	const [offers, setOffers] = React.useState({});
	
	// load product data 
	/*
	 * ComponentDidLoad
	 */
	React.useEffect(() => {
		async function fetchOffers() {
			const _offers = await getOffers();
			setOffers(_offers.boxConfig);
			setLoaded(true);
		}
	
		fetchOffers();
	}, [])
	
	
	React.useEffect(() => {
		setFormData({ ...formData, is_present: present, type: type });
	}, [type, present]);
	
	
	
	React.useEffect(() => {
		const hasSummary = formData.type && formData.capacity && formData.duration;
		if( hasSummary ) {
			const product = offers.Products.find(p => p.type === formData.type && p.capacity == formData.capacity && p.duration === formData.duration );
			setFormData({ ...formData, product });
		}
	}, [formData.type, formData.capacity, formData.duration]);
	
	
	// Ready ?
	if(! loaded ) {
		return <Loader />;
	}
	
	if( saving ) {
		return <Loader />;
	}
	
	
	const _save = async () => {
		setSaving(true);
		
		const data = new FormData();
		data.append('product_id', formData.product.master_id);
		data.append('details[only_red_wine]', formData.only_red_wine ? '1' : '0');
		data.append('details[is_present]', formData.is_present ? '1' : '0');
		data.append('details[custom_message]', formData.message);
		
		const csrf = document.querySelector('meta[name="csrf-token"]');
		if( csrf ) {
			const token = csrf.getAttribute('content');
			data.append('_csrfToken', token);
		}
		
		await addToCart(data);
		setSaving(false);
		// redirect to cart 
		
		document.location.href = cart_url;
	}
	
	// Listeners & Callbacks	
	const _changeContext = event => {
		setFormData({ ...formData, is_present: event.target.checked  });
		/*
		if( event.target.checked  ) {
			document.getElementById('present-message').focus();
		}
		*/
	}
	
	const _changeColor = event => {
		setFormData({ ...formData, only_red_wine: event.target.checked  });
	}
	
	
	const _changeType = type => {
		setFormData({ ...formData, type: type });
		/*
		if(! formData.capacity ) {
			const s = document.getElementById('box-capacity-selector');
			s && s.scrollIntoView();//{behavior: "smooth", block: "end", inline: "nearest"});
		}
		*/
	}
	
	const _changeCapacity = capacity => {
		setFormData({ ...formData, capacity: capacity  });
		/*
		if(! formData.duration ) {
			const s = document.getElementById('box-duration-selector');
			s && s.scrollIntoView();//{ behavior: 'smooth'});
		}
		*/
	}
	
	const _changeDuration = duration => {
		setFormData({ ...formData, duration: duration  });
	}
	
	const _changePresentMessage = event => {
		setFormData({ ...formData, message: event.target.value  });
	}
	
	const _openDetails = () => {
		const details = document.getElementById('box-configuration-details');
		if( details ) {
			details.classList.add('shown');
		}
	}
	
	const _closeDetails = () => {
		const details = document.getElementById('box-configuration-details');
		if( details ) {
			details.classList.remove('shown');
		}
	}
	
	

	
	const _renderSelectors = () => {
		if(! formData.type ) {
			return null;
		}
		
		const products = offers.Products.filter(p => p.type === formData.type);
		const capacities = offers.Capacities.map(c => {
			const ps = products.filter(p => p.capacity === c.id).sort((a, b) => {
				if(a.price === b.price) {
					return 0;
				}
				return a.price > b.price ? 1 : -1;
			});
			
			if( ps.length > 0 ) {
				return { ...c, price: ps[0].price };
			}
			return null;
		}).filter(c => c !== null);
		
		const durationsIds = [...new Set(products.map(p => p.duration))];
		const durations = offers.Durations.filter(d => durationsIds.indexOf(d.id) > -1);
		
		return (
			<>
				<CapacitySelector value={ formData.capacity || null } onChange={ _changeCapacity } options={ capacities } />
				<DurationSelector value={ formData.duration || null } onChange={ _changeDuration } options={ durations } />
			</>
		);
	}
	

	
	return (
		<div className="box-configuration form">
			<div className="box-configuration--main">
				<ScrollView>
					<div className="box-configuration--options">
						<TypeSelector value={ formData.type || null } onChange={ _changeType } options={ offers.Types } />
						{ _renderSelectors() }
					</div>
				</ScrollView>
			</div>
			
			<div id="box-configuration-details" className={ `box-configuration--info${formData.product ? ' has-product' : ''}` }>
				<ScrollView>
					<div className="box-configuration--info-inner">
						<div className="box-configuration--meta">
							<div className="box-configuration--option-present">
								<div className="input checkbox">
									<label>
										<input type="checkbox" className="round" name="only_red_wine" value="1" onChange={ _changeColor } /> 
										{ __("Uniquement des vins rouges s'il vous plaît") }
										
									</label>
								</div>
							</div>
							
							<div className="box-configuration--option-present">
								<div className="input checkbox">
									<label>
										<input type="checkbox" className="round" name="is_present" value="1" onChange={ _changeContext } /> 
										{ __('Je souhaite offrir cet abonnement') }
									</label>
								</div>
								
								{ formData.is_present && (
									<div className="input textarea">
										<label>{ __('Votre message') }</label>
										<textarea 
											id="present-message"
											placeholder={ __("Rédigez un message à l’heureux destinataire de cet abonnement") } 
											name="present_message" 
											rows="8"
											value={ FormData.message }
											onChange={ _changePresentMessage }
										></textarea>
										<div className="box-form-info">{ __('Votre message sera imprimé et placé dans la première box envoyée') }</div>
									</div>
								)}
							</div>
						</div>
						{ formData.product && <FormSummary product={ formData.product } onSave={ _save } onClose={ _closeDetails } /> }
					</div>
				</ScrollView>
			</div>
			
			<div className={ `box-configuration--info-rl${formData.product ? ' has-product' : ''}` }>
				{ formData.product && (
					<>
						<Price amount={ formData.product.price } /> 
						<button className="s2--button large" type="button" onClick={ _openDetails }>{ __('Étape suivante') }</button>
					</>
				)}
			</div>
		</div>
	);
}


const Loader = () => {
	return (
		<div className="box-form--loader">
			<div className="loader">
				<svg 
					version="1.1" 
					xmlns="http://www.w3.org/2000/svg" 
					xmlnsXlink="http://www.w3.org/1999/xlink" 
					x="0px" 
					y="0px"
			    	viewBox="0 0 100 100" 
					enableBackground="new 0 0 0 0" 
					xmlSpace="preserve"
					style={ { width:'72px', height:'72px' } }
				>
					<circle fill="#33030a" stroke="none" cx="6" cy="50" r="6">
						<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
					</circle>
					<circle fill="#33030a" stroke="none" cx="26" cy="50" r="6">
						<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite"  begin="0.2"/>       
					</circle>
					<circle fill="#33030a" stroke="none" cx="46" cy="50" r="6">
						<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
					</circle>
				</svg>
			</div>
		</div>
	);
};